import { useEffect } from "react";
import { useGlobalContext } from "../../hooks/useGlobalContext";
import { notifyError } from "../../services/alertApi";
import axiosApi from "../../services/axiosApi";

const InterceptorsWrapper = () => {
  const { setIsLoading } = useGlobalContext();
  useEffect(() => {
    const requestInterceptor = axiosApi.interceptors.request.use(
      (config) => {
        const configAsAny = config as any;
        
        // Só adiciona token se skipAuth não estiver definido ou for false
        if (!configAsAny.skipAuth) {
          const token = localStorage.getItem("accessToken");
          if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
          }
        }
        
        if (!configAsAny.ignoreLoading) {
          setIsLoading(true);
        }
        return config;
      },
      (error) => {
        setIsLoading(false);
        notifyError();
        return Promise.reject(error);
      }
    );

    const responseInterceptor = axiosApi.interceptors.response.use(
      (response) => {
        setIsLoading(false);
        return response;
      },
      (error: any) => {
        setIsLoading(false);
        const shouldNotifyError = !error?.config?.ignoreErrorNotify;
        if (shouldNotifyError) {
          const status = error?.response?.status;
          const errorData = error?.response?.data;
          const errorMessage = errorData?.errorMessage || errorData?.error || errorData?.message;
          
          if (status === 403) {
            const lowerMessage = errorMessage?.toLowerCase() || "";
            const isPermissionError = 
              lowerMessage.includes("permissão") || 
              lowerMessage.includes("permission") ||
              lowerMessage.includes("não tem permissão") ||
              lowerMessage.includes("sem permissão");
            
            if (isPermissionError) {
              notifyError("Você não tem permissão para realizar esta ação.");
            } else {
              notifyError(errorMessage || "Acesso negado.");
            }
          } else {
            notifyError(errorMessage);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      // Remove interceptors when the component is unmounted
      axiosApi.interceptors.request.eject(requestInterceptor);
      axiosApi.interceptors.response.eject(responseInterceptor);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default InterceptorsWrapper;
